module.exports = __webpack_public_path__ + "618ac3e581cae4aa1aed44ced93ab4c5.jpg";